var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is)?_c('span',{staticClass:"opc-cycle__current-badge",class:_vm.badgeClasses},[_vm._v(_vm._s(_vm.$t('billing.common.billing_cycle_current')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }